module.exports = __webpack_public_path__ + "img/FetteUNZFraktur.a7fc085e.svg";